import { Table } from "reactstrap";
import InvoiceHeader from "./InvoiceHeader";
import InvoiceBackImage from "./InvoiceBackImage";
import InvoiceContent from "./InvoiceContent";
import InvoiceOrder from "./InvoiceOrder";
import InvoiceSign from "./InvoiceSign";
import { useRef } from "react";
import { InvoiceButtons } from "../Common/InvoiceButtons";

const InvoiceOneContainer = () => {
  const contentRef = useRef<HTMLDivElement | null>(null);

  return (
    <>
      <div ref={contentRef}>
        <Table className="table-wrapper" style={{ width: "1120px", margin: "0 auto", background: "#fff" }} borderless>
          <tbody style={{ display: "block", padding: "10px" }}>
            <tr>
              <InvoiceHeader />
            </tr>
            <tr>
              <InvoiceBackImage />
            </tr>
            <tr>
              <InvoiceContent />
            </tr>
            <tr>
              <InvoiceOrder />
            </tr>
          </tbody>
          <tfoot style={{ display: "block", padding: "10px" }}>
            <InvoiceSign />
          </tfoot>
        </Table>
      </div>
      <InvoiceButtons contentRef={contentRef} />
    </>
  );
};

export default InvoiceOneContainer;
